<template>
   <el-tabs type="border-card">
    <el-tab-pane label="BOM管理 > BOM列表">
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="bomForm" class="demo-form-inline">
          <el-form-item label="BOM编号">
            <el-input size="mini" v-model.trim="bomForm.bomNo" placeholder="BOM编号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-bottom:10px;">
        <el-upload
          :action="serverUrl"
          :show-file-list="false"
          list-type="text"
          :headers="myHeaders"
          :before-upload="beforeUpload"
          :on-success="uploadSuccMethod"
          :on-error="uploadFail">
          <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline">上传合同</el-button>
        </el-upload>
      </div>
      <div style="margin-top:10px;">
        <el-table
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="bomNo"
            show-overflow-tooltip
            label="BOM编号">
          </el-table-column>
          <el-table-column
            prop="bomPath"
            show-overflow-tooltip
            label="BOM链接">
          </el-table-column>
          <el-table-column
            width="240"
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="220">
            <template slot-scope="scope">
              <el-link  type="primary" :href="scope.row.bomUrl" target="_blank">预览</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      serverUrl: "https://admin.ruidan.com/api/order/bom/query", // 这里写你要上传的图片服务器地址
        // serverUrl: "http://127.0.0.1:7006/order/bom/query",
      bomForm: {
        bomNo: '',
        token: this.user.getToken()
      },
      myHeaders: {Authorization: this.user.getToken()},
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getBomList()
  },
  methods: {
    getBomList: function() {
      this.optionItem = this.common.extend(this.bomForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/order/bom/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    onSubmit: function() {
      this.getBomList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getBomList()
    },
    uploadSuccMethod(res) {
      console.log("返回图片地址："+res.data)
      this.form.pictureUrl = res.data;
    },
    uploadFail() {
      // loading动画消失
      this.$message.error("图片插入失败");
    },
    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/bom/bomList.vue